//import { mapGetters } from 'vuex';
import {
  enterPusherChannelAndBindEvents,
  leavePusherChannel,
} from 'utils/realTimeEventHelpers';

const school_events = [
  {
    event_name: 'new_suggestion',
    action_name: 'SOCKET_addNewSuggestion',
  },
  {
    event_name: 'edit_suggestion',
    action_name: 'SOCKET_editSuggestion',
  },
  {
    event_name: 'delete_suggestion',
    action_name: 'SOCKET_deleteSuggestion',
  },
];

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    setupSchoolSocket(school_id) {
      enterPusherChannelAndBindEvents.call(this, school_id, school_events);
    },
    leaveSchoolSocket(school_id) {
      leavePusherChannel(school_id);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/sockets/schoolSocketEvents.js